import { filingDebtors } from './debtors';

const PERIOD_MAP = {
  weekly: 'weekly',
  biweekly: 'biweekly',
  'semi-monthly': 'semimonthly',
  semimonthly: 'semimonthly',
  monthly: 'monthly',
};

export function wageOrderPlanPayment(plan, debtors, debtorId) {
  if (!plan || !debtorId) return null;
  const orderedDebtors = filingDebtors(debtors);
  const debtorIndex = orderedDebtors.findIndex(
    (debtor) => String(debtor?.id) === String(debtorId),
  );
  if (debtorIndex < 0 || debtorIndex > 1) return null;

  const debtorNumber = debtorIndex + 1;
  const amount = plan[`payment_debtor_${debtorNumber}`];
  const planPeriod = plan[`payment_period_debtor_${debtorNumber}`] || '';
  return {
    debtorNumber,
    amount: amount === null || amount === undefined ? '' : String(amount),
    period: PERIOD_MAP[planPeriod] || '',
    planPeriod,
    source: plan[`payment_source_debtor_${debtorNumber}`] || '',
  };
}
